export default "__VITE_ASSET__52ffa8c2__"